import {createSelector} from 'reselect';
import {getTranslations, getTripData} from './store';
import {getDeviceSize, getIsMobile, getLocale} from './system';
import {getDatelessAvailabilityData, getShouldShowRates} from './availability';

const getLabels = createSelector(
    [getTranslations, getShouldShowRates],
    (translations, shouldShowRates) => {
        const mainHeading = shouldShowRates
            ? translations.ratesAvailability
            : translations.availability;

        const labels = {
            ratesAvailability: translations.ratesAvailability,
            availability: translations.availability,
            mainHeading,
            taxesAndFeesAdditional: translations.taxesAndFeesAdditional
        };

        return labels;
    }
);

const getCalendarStartMonth = createSelector(
    [getTripData],
    (tripData) => {
        const {arriveDateText} = tripData;
        const dateParts = arriveDateText ? arriveDateText.replace('-0', '-').split('-') : null;

        return arriveDateText ? parseInt(dateParts[1], 10) - 1 : new Date().getMonth();
    }
);

const getCalendarStartYear = createSelector(
    [getTripData],
    (tripData) => {
        const {arriveDateText} = tripData;
        const dateParts = arriveDateText ? arriveDateText.replace('-0', '-').split('-') : null;

        return arriveDateText ? parseInt(dateParts[0], 10) : new Date().getUTCFullYear();
    }
);

const getNumMonths = createSelector(
    [getDeviceSize],
    (deviceSize) => {
        return deviceSize === 'lg' || deviceSize === 'xl' ? 2 : 1;
    }
);

const getNumColumns = createSelector(
    [getDeviceSize],
    (deviceSize) => {
        return deviceSize === 'lg' || deviceSize === 'xl' ? 2 : 1;
    }
);

const getAvailabilityCalendar = createSelector(
    [
        getDatelessAvailabilityData,
        getIsMobile,
        getLocale,
        getLabels,
        getTripData,
        getCalendarStartMonth,
        getCalendarStartYear,
        getNumMonths,
        getNumColumns,
        getShouldShowRates
    ],
    (
        datelessAvailability,
        isMobile,
        locale,
        labels,
        tripData,
        calendarStartMonth,
        calendarStartYear,
        numMonths,
        numColumns,
        shouldShowRates
    ) => {
        return {
            availability: datelessAvailability,
            calendarStartMonth,
            calendarStartYear,
            isMobile,
            locale,
            labels,
            numMonths,
            numColumns,
            selectable: false,
            selectionEnd: tripData.departDateText,
            selectionStart: tripData.arriveDateText,
            shouldShowRates
        };
    }
);

export default getAvailabilityCalendar;
export {
    getLabels,
    getCalendarStartMonth,
    getCalendarStartYear,
    getNumMonths,
    getNumColumns,
    getAvailabilityCalendar
};
